// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditCategory-containerWith-VrSc7 {
    width: 100%;
    max-width: 1260px !important;
    margin: 0 auto;
}

.EditCategory-container-EnRLS {
    max-width: 100%;
}

/* Text - Start */

.EditCategory-subText-G0zUl {
    color: var(--secondary-foreground);
    font-size: 14px;
}

/* Text - End */

/* Header */

.EditCategory-navigationLink-yYf1k a {
    padding-right: 20px !important;
    padding-left: 20px !important;
    color: var(--primary-foreground) !important;
    font-size: 18px;
    border-bottom: 2px solid transparent;
}

.EditCategory-navigationLink-yYf1k a:hover,
.EditCategory-navigationLink-yYf1k a:focus,
.EditCategory-navigationLink-yYf1k a:active {
    border-bottom: 2px solid var(--primary-foreground);
}

/* Header */

/* commonCss */

.EditCategory-noPadding-Pqjok {
    padding: 0;
}

.EditCategory-heading-i61FL {
    padding: 30px 0px 24px 0px;
    font-weight: 700;
    font-size: 24px;
    color: var(--primary-foreground);
}

.EditCategory-widthInner-slmt2 {
    margin: 0px auto 0px auto;
    border-radius: 4px;
    padding: 0px;
    margin: 0px 15px 30px;
}

.EditCategory-noMargin-ndug2 {
    margin: 0;
}

.EditCategory-formControlInputTable-SOWsf {
    border: none;
    width: 100px;
    height: auto;
}

.EditCategory-backBtn-eSYEF {
    margin-left: 15px;
    display: inline-block;
}

.EditCategory-backBtn-eSYEF:active,
.EditCategory-backBtn-eSYEF:hover,
.EditCategory-backBtn-eSYEF:focus {
    color: var(--primary-bg);
    text-decoration: none !important;
}

.EditCategory-textAlignRight-r7lJP {
    text-align: right;
}

.EditCategory-displayInlineBlock-UvVDo {
    display: inline-block;
}

.EditCategory-displayBlock-pWS82 {
    display: block;
}

.EditCategory-countryCode-X7f9K {
    width: 15%;
    vertical-align: top;
}

.EditCategory-vtrMiddle-vnUGw {
    vertical-align: middle;
}

/* commonCss */

.EditCategory-editIcon-oqPkV {
    width: 100%;
    width: 15px;
    vertical-align: middle;
    margin-right: 3px;
}

.EditCategory-iconBtn-qHSAj,
.EditCategory-iconBtn-qHSAj:hover,
.EditCategory-iconBtn-qHSAj:focus {
    padding: 0 !important;
    background: transparent !important;
    color: var(--danger-action-color) !important;
    border: 0 !important;
    white-space: nowrap;
    font-size: 16px !important;
    text-decoration: unset !important;
    cursor: pointer;
}

.EditCategory-profileImg-B_sHV {
    width: 100%;
    height: auto;
    margin-bottom: 18px;
}

.EditCategory-profileImgSection-G4A9v {
    width: 100%;
    margin: 0 auto;
    padding: 30px;
    border-radius: 12px;
    border: 1px solid var(--primary-border);
    background: var(--primary-input-bg);

}

.EditCategory-profileImgWidth-ru3U7 {
    margin: 0;
    max-width: 100% !important;
}

.EditCategory-searchInput-tXrCb {
    width: 100%;
    max-width: 320px;
}

.EditCategory-backgroundImg-t5zSe {
    padding-top: 42%;
    background-repeat: no-repeat;
    background-size: contain;
    margin-bottom: 18px;
    border-radius: 4px;
    background-color: transparent;
    background-position: center;
    margin-top: 6px;
    border: 1px dashed var(--primary-border);
    border-radius: 12px;
}

/*******************Export CSV section start ******************/

.EditCategory-exportDisplay-dvRep {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    margin-bottom: 18px;
    gap: 18px;
    grid-gap: 18px;
}

.EditCategory-exportTextSection-QULE7 {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 12px;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
}

.EditCategory-exportText-bJu51 {
    display: inline-block;
    padding-right: 5px;
}

.EditCategory-exportTextContainer-Cktdd {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    color: var(--primary-link-foreground) !important;
    text-decoration: unset !important;
    border-bottom: 1px solid var(--primary-link-foreground);
}

.EditCategory-vtrTextBottom-UjhNv {
    vertical-align: text-bottom;
}

.EditCategory-exportImg-lkdwO {
    width: 100%;
    max-width: 14px;
    height: 14px;
    -o-object-fit: contain;
       object-fit: contain;
}

/*******************Export CSV section End ******************/

.EditCategory-noLink-eVkCr,
.EditCategory-noLink-eVkCr:hover {
    color: var(--primary-link-foreground) !important;
    cursor: pointer;
}

.EditCategory-singleCard-xFVuG {
    width: 500px;
    margin: 0 auto;
}

.EditCategory-defaultIcon-qEe0V {
    background-size: 50px;
}

.EditCategory-assignProviderSearchInput-N1KQY {
    width: 100%;
    max-width: 324px;
}

.EditCategory-searchGroupContainer-XccDI {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 12px;
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
}

@media (max-width: 767px) {
    .EditCategory-searchGroupContainer-XccDI {
        width: 100%;
    }

}`, "",{"version":3,"sources":["webpack://./src/components/Common.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA,iBAAiB;;AACjB;IACI,kCAAkC;IAClC,eAAe;AACnB;;AAEA,eAAe;;AAEf,WAAW;;AAEX;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,2CAA2C;IAC3C,eAAe;IACf,oCAAoC;AACxC;;AAEA;;;IAGI,kDAAkD;AACtD;;AAEA,WAAW;;AAEX,cAAc;;AACd;IACI,UAAU;AACd;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;;;IAGI,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,cAAc;;AAEd;IACI,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;;;IAGI,qBAAqB;IACrB,kCAAkC;IAClC,4CAA4C;IAC5C,oBAAoB;IACpB,mBAAmB;IACnB,0BAA0B;IAC1B,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,mCAAmC;;AAEvC;;AAEA;IACI,SAAS;IACT,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;IAC7B,2BAA2B;IAC3B,eAAe;IACf,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA,+DAA+D;;AAC/D;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,mBAAe;QAAf,eAAe;IACf,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,mBAAe;QAAf,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,gDAAgD;IAChD,iCAAiC;IACjC,uDAAuD;AAC3D;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;AACvB;;AAEA,6DAA6D;;AAC7D;;IAEI,gDAAgD;IAChD,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;AAChB;;AAEA;IACI;QACI,WAAW;IACf;;AAEJ","sourcesContent":[".containerWith {\n    width: 100%;\n    max-width: 1260px !important;\n    margin: 0 auto;\n}\n\n.container {\n    max-width: 100%;\n}\n\n/* Text - Start */\n.subText {\n    color: var(--secondary-foreground);\n    font-size: 14px;\n}\n\n/* Text - End */\n\n/* Header */\n\n.navigationLink a {\n    padding-right: 20px !important;\n    padding-left: 20px !important;\n    color: var(--primary-foreground) !important;\n    font-size: 18px;\n    border-bottom: 2px solid transparent;\n}\n\n.navigationLink a:hover,\n.navigationLink a:focus,\n.navigationLink a:active {\n    border-bottom: 2px solid var(--primary-foreground);\n}\n\n/* Header */\n\n/* commonCss */\n.noPadding {\n    padding: 0;\n}\n\n.heading {\n    padding: 30px 0px 24px 0px;\n    font-weight: 700;\n    font-size: 24px;\n    color: var(--primary-foreground);\n}\n\n.widthInner {\n    margin: 0px auto 0px auto;\n    border-radius: 4px;\n    padding: 0px;\n    margin: 0px 15px 30px;\n}\n\n.noMargin {\n    margin: 0;\n}\n\n.formControlInputTable {\n    border: none;\n    width: 100px;\n    height: auto;\n}\n\n.backBtn {\n    margin-left: 15px;\n    display: inline-block;\n}\n\n.backBtn:active,\n.backBtn:hover,\n.backBtn:focus {\n    color: var(--primary-bg);\n    text-decoration: none !important;\n}\n\n.textAlignRight {\n    text-align: right;\n}\n\n.displayInlineBlock {\n    display: inline-block;\n}\n\n.displayBlock {\n    display: block;\n}\n\n.countryCode {\n    width: 15%;\n    vertical-align: top;\n}\n\n.vtrMiddle {\n    vertical-align: middle;\n}\n\n/* commonCss */\n\n.editIcon {\n    width: 100%;\n    width: 15px;\n    vertical-align: middle;\n    margin-right: 3px;\n}\n\n.iconBtn,\n.iconBtn:hover,\n.iconBtn:focus {\n    padding: 0 !important;\n    background: transparent !important;\n    color: var(--danger-action-color) !important;\n    border: 0 !important;\n    white-space: nowrap;\n    font-size: 16px !important;\n    text-decoration: unset !important;\n    cursor: pointer;\n}\n\n.profileImg {\n    width: 100%;\n    height: auto;\n    margin-bottom: 18px;\n}\n\n.profileImgSection {\n    width: 100%;\n    margin: 0 auto;\n    padding: 30px;\n    border-radius: 12px;\n    border: 1px solid var(--primary-border);\n    background: var(--primary-input-bg);\n\n}\n\n.profileImgWidth {\n    margin: 0;\n    max-width: 100% !important;\n}\n\n.searchInput {\n    width: 100%;\n    max-width: 320px;\n}\n\n.backgroundImg {\n    padding-top: 42%;\n    background-repeat: no-repeat;\n    background-size: contain;\n    margin-bottom: 18px;\n    border-radius: 4px;\n    background-color: transparent;\n    background-position: center;\n    margin-top: 6px;\n    border: 1px dashed var(--primary-border);\n    border-radius: 12px;\n}\n\n/*******************Export CSV section start ******************/\n.exportDisplay {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    align-items: center;\n    margin-bottom: 18px;\n    gap: 18px;\n    grid-gap: 18px;\n}\n\n.exportTextSection {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.exportText {\n    display: inline-block;\n    padding-right: 5px;\n}\n\n.exportTextContainer {\n    display: flex;\n    align-items: center;\n    color: var(--primary-link-foreground) !important;\n    text-decoration: unset !important;\n    border-bottom: 1px solid var(--primary-link-foreground);\n}\n\n.vtrTextBottom {\n    vertical-align: text-bottom;\n}\n\n.exportImg {\n    width: 100%;\n    max-width: 14px;\n    height: 14px;\n    object-fit: contain;\n}\n\n/*******************Export CSV section End ******************/\n.noLink,\n.noLink:hover {\n    color: var(--primary-link-foreground) !important;\n    cursor: pointer;\n}\n\n.singleCard {\n    width: 500px;\n    margin: 0 auto;\n}\n\n.defaultIcon {\n    background-size: 50px;\n}\n\n.assignProviderSearchInput {\n    width: 100%;\n    max-width: 324px;\n}\n\n.searchGroupContainer {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-grow: 1;\n}\n\n@media (max-width: 767px) {\n    .searchGroupContainer {\n        width: 100%;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerWith": `EditCategory-containerWith-VrSc7`,
	"container": `EditCategory-container-EnRLS`,
	"subText": `EditCategory-subText-G0zUl`,
	"navigationLink": `EditCategory-navigationLink-yYf1k`,
	"noPadding": `EditCategory-noPadding-Pqjok`,
	"heading": `EditCategory-heading-i61FL`,
	"widthInner": `EditCategory-widthInner-slmt2`,
	"noMargin": `EditCategory-noMargin-ndug2`,
	"formControlInputTable": `EditCategory-formControlInputTable-SOWsf`,
	"backBtn": `EditCategory-backBtn-eSYEF`,
	"textAlignRight": `EditCategory-textAlignRight-r7lJP`,
	"displayInlineBlock": `EditCategory-displayInlineBlock-UvVDo`,
	"displayBlock": `EditCategory-displayBlock-pWS82`,
	"countryCode": `EditCategory-countryCode-X7f9K`,
	"vtrMiddle": `EditCategory-vtrMiddle-vnUGw`,
	"editIcon": `EditCategory-editIcon-oqPkV`,
	"iconBtn": `EditCategory-iconBtn-qHSAj`,
	"profileImg": `EditCategory-profileImg-B_sHV`,
	"profileImgSection": `EditCategory-profileImgSection-G4A9v`,
	"profileImgWidth": `EditCategory-profileImgWidth-ru3U7`,
	"searchInput": `EditCategory-searchInput-tXrCb`,
	"backgroundImg": `EditCategory-backgroundImg-t5zSe`,
	"exportDisplay": `EditCategory-exportDisplay-dvRep`,
	"exportTextSection": `EditCategory-exportTextSection-QULE7`,
	"exportText": `EditCategory-exportText-bJu51`,
	"exportTextContainer": `EditCategory-exportTextContainer-Cktdd`,
	"vtrTextBottom": `EditCategory-vtrTextBottom-UjhNv`,
	"exportImg": `EditCategory-exportImg-lkdwO`,
	"noLink": `EditCategory-noLink-eVkCr`,
	"singleCard": `EditCategory-singleCard-xFVuG`,
	"defaultIcon": `EditCategory-defaultIcon-qEe0V`,
	"assignProviderSearchInput": `EditCategory-assignProviderSearchInput-N1KQY`,
	"searchGroupContainer": `EditCategory-searchGroupContainer-XccDI`
};
module.exports = ___CSS_LOADER_EXPORT___;
